export default {
  'app.org.title': '全部组织',
  'app.org.column.id': '组织ID',
  'app.org.column.name': '组织名称',
  'app.org.column.timezone': '时区',
  'app.org.column.website': '组织网址',
  'app.org.column.isCreator': '是否为创建人',
  'app.org.column.createTime': '创建时间',
  'app.org.column.operate': '操作',
  'app.org.column.operate.enter': '进入',
  'app.org.column.operate.edit': '编辑',
  'app.org.column.operate.delete': '删除',
  'app.org.column.operate.placeholder': '请输入组织名称/组织ID',
  'app.org.create': '建立组织',
  'app.org.create.submit': '创建组织',
  'app.org.bind.tip': '创建新组织',
  'app.org.create.tip': '已有组织？',
  'app.org.create.tip.bind': '去绑定',
  'app.org.success.tip': '返回控制台',
  'app.org.bind': '绑定组织',
  'app.org.bind.submit': '完成绑定',
  'app.org.create.create': '创建',
  'app.org.create.save': '保存',
  'app.org.create.cancel': '取消',
  'app.org.create.profile': '组织信息',
  'app.org.create.name.placeholder': '输入组织名称',
  'app.org.create.website.placeholder': '输入网址包含（.顶级域名）',
  'app.org.create.timezone': '时区选择',
  'app.org.create.timezone.tip': '（时区一旦选定，将无法更改）',
  'app.org.create.currency': '帐单币种',
  'app.org.create.usd': '美元',
  'app.org.create.success': '创建成功',
  'app.org.edit.success': '编辑成功',
  'app.org.rule.blank': '内容不得为空',
  'app.org.rule.char': '角色名称禁止输入非法字符',
  'app.org.rule.name.exists': '组织名称已存在',
  'app.org.rule.url.exists': '该网址已存在',
  'app.org.rule.url.start': '请输入 www 开头网址',
  'app.org.delete.title': '删除组织',
  'app.org.delete.content':
    '警告！删除组织操作为不可逆，将永久删除该组织内的用户、业务、余额、帐单、订单和权益等资料和信息，同时停止所有相关服务。 ',
  'app.org.delete.warn': '无法删除帐户，该帐户必须无待补缴的帐单，否则将无法删除！ ',
  'app.org.delete.cancel': '取消',
  'app.org.delete.next': '下一步',
  'app.org.delete.delete': '删除',
  'app.org.delete.confirm': '确认删除组织',
  'app.org.delete.confirm.content':
    '您提交的删除帐户申请生效前，我们将进行下列验证事项，以确保您的帐号安全。请检查电子邮件中的验证码信息',
  'app.org.delete.confirm.send': '发送验证码',
  'app.org.delete.confirm.send.resend': '重新发送验证码',
  'app.org.delete.confirm.resend': '重新发送',
  'app.org.delete.confirm.rule': '请输入正确的验证码',
  'app.org.delete.success': '删除成功',
  'app.org.delete.balance': '该组织存在余额，无法删除',
};
